<template>
    <div class="">
        <div class="HeaderTop">
            <div class="SearchHead">
                <el-input size="medium" placeholder="搜索" v-model="SearchVal" @keyup.enter.native="ReSetPage">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="ReSetPage"></i>
                </el-input>
            </div>
            <div class="BtnHead">
                <el-button v-throttle v-if="SeleId.length>0" class="BgColor" size="small" type="danger" @click="Delete('')">批量删除</el-button>
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="ToggleDig('Add')">新增配置</el-button>
            </div>
        </div>
        <el-table :data="Data" border stripe style="width: 100%;" class="custom-header-table" v-loading="loading" @selection-change="TabChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="indicator" label="名称" min-width="100"></el-table-column>
            <el-table-column prop="description" label="描述" min-width="200">
                <template slot-scope="scope">
                     <el-input v-if="scope.row.description" readonly :autosize="{ minRows: 2, maxRows: 8 }" class="Wid" type="textarea" size="medium" placeholder="请输入描述" v-model="scope.row.description"></el-input>
                </template>
            </el-table-column>
            <el-table-column prop="field_name" label="所属领域" min-width="70"></el-table-column>
            <el-table-column prop="weight" label="权重" min-width="50"></el-table-column>
            <el-table-column prop="score" label="分值" min-width="50"></el-table-column>
            <el-table-column prop="template_names" label="是否使用" min-width="50"></el-table-column>
            <el-table-column prop="status" label="状态" min-width="50">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#ddd"
                    :active-value="1" :inactive-value="0" @change="ToggleStatus(scope.row)" />
                </template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" min-width="100"></el-table-column>
            <el-table-column label="操作" min-width="120" align="center">
                <template slot-scope="scope">
                    <el-tooltip effect="dark" content="编辑" placement="top-start">
                        <i class="NavIcon el-icon-edit"@click="ToggleDig(scope.row)"></i>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="删除" placement="top-start">                        <i class="NavIcon el-icon-delete" @click="Delete(scope.row.id)"></i>                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background @size-change="SizeChange" @current-change="PageChange" :current-page="Page" 
            layout="total,prev,pager,next,sizes"
            :total="Totol" hide-on-single-page>
        </el-pagination>
        <el-dialog :title="Type=='Add'?'新增规则':'修改规则'" :visible.sync="NewData.NewBlon" width="40%" class="BorderRadius">
            <div class="DigItem">
                <div class="DigItemTit">名称：</div>
                <el-input class="Wid" size="medium" placeholder="请输入名称" v-model="NewData.indicator"></el-input>
            </div>
            <div class="DigItem">
                <div class="DigItemTit">描述：</div>
                <el-input class="Wid" type="textarea" :rows="2" size="medium" placeholder="请输入描述" v-model="NewData.description"></el-input>
            </div>
            <div class="DigItem">
                <div class="DigItemTit">所属领域：</div>
                <el-select class="Wid" size="medium" v-model="NewData.field_ids" placeholder="请选择所属领域">
                    <el-option v-for="item in LingYuList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </div> 
            <div class="DigItem">
                <div class="DigItemTit">权重：</div>
                <el-input class="Wid" size="medium" placeholder="请输入权重" v-model="NewData.weight"></el-input>
            </div>
            <div class="DigItem">
                <div class="DigItemTit">分值：</div>
                <el-input class="Wid" size="medium" placeholder="请输入总分值" v-model.number="NewData.score"></el-input>
            </div>
            <div v-if="NewData.score" class="DigItem">
                <div class="DigItemTit">分值提示：</div>
                <div>
                    <div v-for="(item, index) in NewData.scoreRanges" :key="index" class="DisFlex">
                        <el-input class="ScoreWid" v-model.number="item.minScore" placeholder="最小值" size="medium"></el-input>
                        <el-input class="ScoreWid" v-model.number="item.maxScore" placeholder="最大值" size="medium"></el-input>
                        <el-input v-model="item.tipText" placeholder="提示文字" size="medium"></el-input>
                        <i class="el-icon-delete ScoreDel" @click="removeRange(index)"></i>
                    </div>
                    <div v-if="rangeError" class="ErrorMsg"> {{ rangeError }}</div>
                </div>
                <el-button v-throttle size="mini" type="primary" icon="el-icon-plus" circle @click="addRange"></el-button>
                <!-- <el-input type="textarea" :rows="2" class="Wid" size="medium" placeholder="请输入分值提示" v-model="NewData.scoreRanges"></el-input> -->
            </div>
            <div class="DigItem">
                <div class="DigItemTit">状态：</div>
                <el-switch class="Wid" v-model="NewData.status" active-color="#13ce66" inactive-color="#ddd" 
                    :active-value="1" :inactive-value="0"/>
            </div>
            <div slot="footer">
                <el-button v-throttle size="small" @click="$Tools.ResetData(NewData)">取消</el-button>
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="Suc">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "AdminIndex",
        data() {
            return {
                loading:false,
                SearchVal:"",
                Data: [],
                Page:1,
                PageSize:10,
                Totol:0,
                SeleId:[],
                Type:'Add',
                rangeError: '', 
                LingYuList:'',
                NewData:{
                    id:'',
                    NewBlon:false,
                    indicator:"",
                    description:"",
                    weight:1,
                    score:"",
                    status:false,
                    scoreRanges:[],
                    field_ids:"",
                    field_name:"",
                },
            };
        },
        mounted() {
            this.GetData();
            this.GetLingYuList();
        },
        methods: {
            GetData(){
                this.loading = true;
                this.$get('/admin/score_rule/index',{
                    keyword:this.SearchVal,
                    page:this.Page,
                    page_size:this.PageSize,
                }).then(res=>{
                    this.loading = false;
                    if(res){
                        this.Data = res.data.list;
                        this.Totol = res.data.total;
                    }
                })
            },
            GetLingYuList(){
                this.$get('/admin/expert_field/index').then(res=>{
                    if(res){
                        this.LingYuList = res.data;
                    }
                })
            },
            TabChange(val){
                this.SeleId = val.map(item => item.id);
            },
            // 添加分值区间
            addRange() {
                this.NewData.scoreRanges.push({
                    minScore: "",
                    maxScore: "",
                    tipText: ''
                });
                this.rangeError = '';
            },
            removeRange(index) {
                this.NewData.scoreRanges.splice(index, 1);
                this.rangeError = '';
            },
            // 校验分值区间合法性 - 修复核心逻辑
            validateRanges() {
                if(this.NewData.scoreRanges.length==0){
                    return true;
                }
                const { score, scoreRanges } = this.NewData;
                this.rangeError = '';
                // 1. 检查是否有空值
                for (let i = 0; i < scoreRanges.length; i++) {
                    const item = scoreRanges[i];
                    if (item.minScore === '' || item.minScore === undefined || item.minScore === null) {
                        this.rangeError = `第${i+1}个区间最小值不能为空`;
                        return false;
                    }
                    if (item.maxScore === '' || item.maxScore === undefined || item.maxScore === null) {
                        this.rangeError = `第${i+1}个区间最大值不能为空`;
                        return false;
                    }
                    if (!item.tipText) {
                        this.rangeError = `第${i+1}个区间提示文字不能为空`;
                        return false;
                    }
                }
                // 2. 检查区间是否超出总分值范围
                for (let item of scoreRanges) {
                    if (item.minScore < 0 || item.maxScore > score) {
                        this.rangeError = '区间值不能超出总分值范围';
                        return false;
                    }
                    if (item.minScore >= item.maxScore) {
                        this.rangeError = '区间最小值必须小于最大值';
                        return false;
                    }
                }
                // 3. 检查区间是否重叠
                const sortedRanges = [...scoreRanges].sort((a, b) => a.minScore - b.minScore);
                for (let i = 1; i < sortedRanges.length; i++) {
                    if (sortedRanges[i].minScore <= sortedRanges[i-1].maxScore) {
                        this.rangeError = '区间不能重叠，请调整范围';
                        return false;
                    }
                }
                // 4. 第一个区间的最小值必须是0，最后一个区间的最大值必须是总分值，且相邻区间连续
                if (sortedRanges[0].minScore !== 0) {
                    this.rangeError = '区间必须从0开始';
                    return false;
                }
                if (sortedRanges[sortedRanges.length - 1].maxScore !== score) {
                    this.rangeError = '最后一个区间的最大值必须等于总分值';
                    return false;
                }
                // 检查相邻区间是否连续（前一个的最大值+1 = 后一个的最小值）
                for (let i = 1; i < sortedRanges.length; i++) {
                    if (sortedRanges[i].minScore !== sortedRanges[i-1].maxScore + 1) {
                        this.rangeError = '区间存在间隙，请调整范围';
                        return false;
                    }
                }
                return true;
            },
            SeleChange(val){
                if(val=='select' || val=='radio'|| val=='checkbox'){
                    this.NewData.field_options = [{"value": ""}];
                }else{
                    this.NewData.field_options = "";
                }
            },
            ToggleDig(row){
                this.$Tools.ResetData(this.NewData)
                this.rangeError = '';
                if(row!='Add'){
                    this.Type='Edi';
                    this.NewData.id = row.id;
                    this.NewData.indicator = row.indicator;
                    this.NewData.score = row.score;
                    this.NewData.description = row.description;
                    this.NewData.weight = row.weight;
                    this.NewData.status = row.status;
                    this.NewData.scoreRanges = row.text_content?JSON.parse(row.text_content):[];
                    this.NewData.field_ids = row.field_ids;
                    this.NewData.field_name = row.field_name;
                }else{
                    this.Type='Add';
                    this.NewData.weight = 1;
                }
                this.NewData.NewBlon = true;
            },
            Suc(){
                if (this.NewData.score > 0 && !this.validateRanges()) {
                    return;
                }
                if (this.NewData.field_ids) {
                    this.NewData.field_name =this.LingYuList.find(row => row.id === this.NewData.field_ids).name;
                }
                if(this.Type=='Add'){
                    this.SucNew();
                }else{
                    this.SucEdit();
                }
                this.rangeError = '';
            },
            SucEdit(){
                this.$post('/admin/score_rule/update',{
                    "id":this.NewData.id,
                    "indicator": this.NewData.indicator,
                    "score": this.NewData.score,
                    "description": this.NewData.description,
                    "weight": this.NewData.weight,
                    "status": this.NewData.status,
                    "text_content": JSON.stringify(this.NewData.scoreRanges),
                    "field_ids": this.NewData.field_ids,
                    "field_name": this.NewData.field_name,
                }).then(res=>{
                    if(res){
                        this.$message.success("修改成功");
                        this.GetData();
                        this.$Tools.ResetData(this.NewData)
                    }
                })
            },
            SucNew(row) {
                this.$post('/admin/score_rule/save',{
                    "indicator": this.NewData.indicator,
                    "score": this.NewData.score,
                    "status": this.NewData.status,
                    "description": this.NewData.description,
                    "weight": this.NewData.weight,
                    "text_content": JSON.stringify(this.NewData.scoreRanges),
                    "field_ids": this.NewData.field_ids,
                    "field_name": this.NewData.field_name,
                }).then(res=>{
                    if(res){
                        this.$message.success("添加成功");
                        this.ReSetPage();
                        this.$Tools.ResetData(this.NewData)
                    }
                })
            },
            Delete(id) {
                var Ids = id!=""?[id]:this.SeleId;
                this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                    type: "warning"
                }).then(() => {
                    this.$del('/admin/score_rule/delete',{
                        ids:Ids,
                    }).then(res=>{
                        if(res){
                            this.$message.success("删除成功!");
                            this.GetData();
                        }
                    })
                })
            },
            ToggleStatus(row){
                this.$post('/admin/score_rule/toggleStatus',{
                    ids:[row.id],
                    status:row.status,
                }).then(res=>{
                    if(res){
                        this.$message.success("修改成功!");
                        this.GetData();
                    }
                })
            },
            FlodAdd(){
                this.NewData.field_options.push({"value": ""});
            },
            FlodRemove(i){
                this.NewData.field_options.splice(i,1);
            },
            SizeChange(val){
                this.PageSize = val;
                this.GetData();
            },
            PageChange(val){
                this.Page = val;
                this.GetData();
            },
            ReSetPage(){
                this.Page = 1;
                this.GetData();
            },
        }
    };
</script>

<style scoped>
    .DisPos{
        width: 85px;
        position: relative;
        margin-right: 10px;
        margin-bottom: 10px;
    }
    .DisAbs{
        position: absolute;
        top: 0;
        right: 0;
        font-size: 14px;
        color: #d51938;
    }
    .DisFlex{
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 10px;
        margin-right: 20px;
    }
    .ScoreWid{
        width: 120px;
    }
    .ScoreDel{
        color: #f56c6c; 
        cursor: pointer;
    }
    .ErrorMsg{
        color: #f56c6c; 
        font-size: 12px;
        margin-top: 5px;
    }
</style>